import React, { Fragment, useContext } from "react";
import { useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
// import ConfigContext from "../../context/config/ConfigContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const ContractDetail = (props) => {
  const cardContext = useContext(CardContext);
  const { isLoading, selectedContract } = cardContext;
  // const configContext = useContext(ConfigContext);
  // const { getConfigValue } = configContext;
  const contract = selectedContract;
  const navigationContext = useContext(NavigationContext);
  const { setNavigationPage } = navigationContext;
  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Contract Details",
  });

  const backToHome = () => {
    setNavigationPage("Recharge");
    history.goBack();
  };
  console.log("DETAIL FOR:", selectedContract);

  return (
    <Fragment>
      {isLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      {selectedContract && (
        <div
          className="patronHome"
          role="main"
          ref={props.mainContentRef}
          tabIndex="-1"
        >
          <h1 id="pageHeader" className="pageTitle patronHome__pageTitle">
            CONTRACT ACTIVITY
          </h1>
          <div className="CardItem">
            <Row>
              <Col className="CardItem__cardTitle">
                <h2>CARD INFORMATION</h2>
              </Col>
            </Row>
            <Row className="CardItem__cardTitle__cardItems">
              <Col lg={12}>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5"> Serial#:</Col>
                  <Col>
                    <strong>{contract.cardSerialNumber}</strong>
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5"> Contract:</Col>
                  <Col>
                    <strong>{contract.family}</strong>
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5">Contract Name: </Col>
                  <Col>
                    <strong>{contract.contractName}</strong>
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5">Contract Type:</Col>
                  <Col>
                    <strong> {contract.family}</strong>
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5">Creation Date/Time: </Col>
                  <Col>
                    <strong>
                      <Moment
                        format="MM/DD/YYYY hh:mm A"
                        tz={env.REACT_APP_HMW_TIME_ZONE}
                      >
                        {contract.emission}
                      </Moment>
                    </strong>
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5">Last Reload Date/Time: </Col>
                  <Col>
                    {moment.utc(contract.lastReload).isBefore("0001-01-01") ? (
                      ""
                    ) : (
                      <strong>
                        <Moment
                          format="MM/DD/YYYY hh:mm A"
                          tz={env.REACT_APP_HMW_TIME_ZONE}
                        >
                          {contract.lastReload}
                        </Moment>
                      </strong>
                    )}
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="5">Balance: </Col>
                  <Col>
                    <strong>${(contract.unitsLeft / 100).toFixed(2)}</strong>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="CardItemGrid">
            <div className="CardItemGrid__cardRowTitle">DATE</div>
            <div className="CardItemGrid__cardRowTitle">
              ACTIVITY DESCRIPTION
            </div>
            <div className="CardItemGrid__cardRowTitle">BILLED</div>
            <div className="CardItemGrid__cardRowTitle">BEFORE($)</div>
            <div className="CardItemGrid__cardRowTitle">CHANGE ON CARD</div>
            <div className="CardItemGrid__cardRowTitle">BALANCE($)</div>
            {/* <div className="CardItemGrid__cardTitle__lineItem">
              12/07/2021 08:44 PM
            </div>
            <div className="CardItemGrid__cardTitle__lineItem">
              ReloadRequestFromCardList
            </div>
            <div className="CardItemGrid__cardTitle__lineItem">$10.0</div>
            <div className="CardItemGrid__cardTitle__lineItem">$25.0</div>
            <div className="CardItemGrid__cardTitle__lineItem">$10.0</div>
            <div className="CardItemGrid__cardTitle__lineItem">$25.0</div> */}
            {contract.contractActivities &&
              contract.contractActivities.map((item) => (
                <Fragment>
                  <div className="CardItemGrid__cardTitle__lineItem">
                    <Moment
                      format="MM/DD/YYYY hh:mm A"
                      tz={env.REACT_APP_HMW_TIME_ZONE}
                    >
                      {item.date}
                    </Moment>
                  </div>
                  <div className="CardItemGrid__cardTitle__lineItem">
                    {item.activityType}
                  </div>
                  <div className="CardItemGrid__cardTitle__lineItem">
                    {" "}
                    ${(item.units / 100).toFixed(2)}{" "}
                  </div>
                  <div className="CardItemGrid__cardTitle__lineItem">
                    {" "}
                    ${(item.unitsBefore / 100).toFixed(2)}{" "}
                  </div>
                  <div className="CardItemGrid__cardTitle__lineItem">
                    ${(item.units / 100).toFixed(2)}
                  </div>
                  <div className="CardItemGrid__cardTitle__lineItem">
                    {" "}
                    ${(item.unitsAfter / 100).toFixed(2)}{" "}
                  </div>
                </Fragment>
              ))}
          </div>
          {/* <div className="CardItem">
            <Row className="CardItem__cardRowTitle">
              <Col lg="3">DATE</Col>
              <Col lg="2">ACTIVITY DESCRIPTION</Col>
              <Col lg="1">BILLED</Col>
              <Col lg="2">BEFORE($)</Col>
              <Col lg="2">CHANGE ON CARD</Col>
              <Col lg="2">BALANCE($)</Col>
            </Row>
            <Row className="CardItem__cardTitle__lineItem">
              <Col lg="3">12/07/2021 08:44 PM</Col>
              <Col lg="2">ReloadRequestFromCardList</Col>
              <Col lg="1">$10.0</Col>
              <Col lg="2">$25.0</Col>
              <Col lg="2">$10.0</Col>
              <Col lg="2">$25.0</Col>
            </Row>
            {contract.contractActivities &&
              contract.contractActivities.map((item) => (
                <Fragment>
                  <Row className="CardItem__cardTitle__lineItem">
                    <Col lg="3">
                      <Moment
                        format="MM/DD/YYYY hh:mm A"
                        tz={env.REACT_APP_HMW_TIME_ZONE}
                      >
                        {item.date}
                      </Moment>
                    </Col>
                    <Col lg="2">{item.activityType}</Col>
                    <Col lg="1"> ${(item.units / 100).toFixed(2)} </Col>
                    <Col lg="2"> ${(item.unitsBefore / 100).toFixed(2)} </Col>
                    <Col lg="2">${(item.units / 100).toFixed(2)}</Col>
                    <Col lg="2"> ${(item.unitsAfter / 100).toFixed(2)} </Col>
                  </Row>
                </Fragment>
              ))}
          </div> */}
          <div id="pageAction" className="patronHome__actionPanel">
            <button
              aria-label="Back "
              name="backHome"
              className="btn btn-primary patronHome__actionPanel__button"
              onClick={backToHome}
            >
              Back
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ContractDetail;
